import { createNode } from '@glueapp/graph-types';

export const NaturalLogarithm = createNode({
    id: 'Natural Logarithm',
    name: 'Natural Logarithm',
    description: 'Gives the natural logarithm of the input number',
    aiDescription:
        'Computes the natural logarithm (base e) of a number. Connect a value to the "Number" input port; the "Logarithm" output port provides the result.',
    category: 'Math',
    color: '#5daa5b',
    integration: undefined,
    inPorts: {
        Number: { kind: 'number' },
    },
    outPorts: {
        Logarithm: { kind: 'number' },
    },
    execute: function (input) {
        const inputNumber = input.inPorts.Number;
        return { output: { Logarithm: Math.log(inputNumber) } };
    },
});
